import { useState, useEffect, useContext } from "react";
import Modal from "../../Shared/PopupModal/PopupModal";
import Autosuggestor from "../AutoComplete";
import classes from "../../TrucksAvailable/TrucksAvailable.module.css";
import Rating from "react-rating";
import { Activity, currentRequestTimeStamp } from "../../../Constants";
import { toast } from "react-toastify";
import axios from "../../../Axios";
import { Urls } from "../../../Urls";
import Loader from "../../Loader";
import { debounce } from "lodash";
import mixpanel from "mixpanel-browser";
import { checkModuleAccess } from "../../../Utility";
import { mailerAPI } from "../../Freightrates1/Utility";
import ProfileModal from "../../TransporterClientScreen/ProfileModal/ProfileModal";
import { useIndentTracking } from "../hooks/useIndentTracking";
import { UserApiContext } from "../../UserDetailsContext/UserDetailsContext";
const PrivateMarketplace = ({
  item,
  // index,
  getIndents,
  todaydate,
  emailTemplate,
  // setnewfilters
  companyId,
}) => {
  const [show, setshow] = useState(false);
  const [transporterList, settransporterList] = useState([]);
  const [existingTransporters, setexistingTransporters] = useState([]);
  // const [marketplaceDetails, setmarketplaceDetails] = useState(item.indent_info)
  const [placementDate, setplacementDate] = useState();
  const [terms, setterms] = useState([]);
  const { userDetails } = useContext(UserApiContext);
  const closeModal = () => {
    document.getElementById("close_contactus").click();
  };

  const { trackIndentEvent } = useIndentTracking()
  useEffect(() => {
    trackIndentEvent("indent request", "user has clicked on private marketplace button", `display indent id: ${item.display_indent_id}`)

    var mindate = item.indent_info.placement_date;
    var day = mindate.split("-")[0];
    var month = mindate.split("-")[1];
    var year = mindate.split("-")[2];
    // console.log(day + month + year)
    var currentdate = year + "-" + month + "-" + day;
    setplacementDate(currentdate);
    setshow(true);
    var final_list = [];
    axios
      .get(`${Urls.MyAccount.Get.RatedTransporters}?my_transporters=true`)
      .then((res) => {
        if (res.data) {
          // console.log(res.data.transporter_list)
          final_list = res.data.transporter_list;
          var list = [];
          final_list = res.data.transporter_list;
          // var list = [];
          list = item.summary.map((item) => {
            if (
              !final_list.some(
                (finalItem) => finalItem.transporter_id === item.transporter_id
              )
            ) {
              final_list.push(item);
            }
            return item.transporter_id;
          });
          // list = item.summary.map(item => {
          //     // final_list.push(item)
          //     return item.transporter_id
          //     // list.push(item.transporter_id)
          // })
          // console.log(list)
          setexistingTransporters(list);
          // var final_list = res.data.transporter_list
          settransporterList(final_list);
          setshow(true);
          axios
            .get(
              `${Urls.companyProfile}?company_id=${companyId}&projections_enable=terms_and_conditions`
            )
            .then((res) => {
              // console.log(res.data)
              setterms(
                res.data[0].terms_and_conditions
                  ? res.data[0].terms_and_conditions.primary
                  : {}
              );
              setshow(false);
            })
            .catch((err) => {
              console.log(err);
              setshow(false);
            });
          // setshow(false)
        }
      })
      .catch((err) => {
        console.log(err);
        setshow(false);
      });
  }, []);

  const ViewLsp = () => {
    const [togglesearch, settogglesearch] = useState(false);
    const [searchText, setSearchText] = useState();

    const check_selection = (e, data) => {
      if (e.target.checked) {
        data.is_shortlist = true;
      } else {
        data.is_shortlist = true;
      }
    };

    const addtolist = (e) => {
      var list = [];
      var temp = transporterList;
      if (temp && temp.length > 0) {
        temp.map((data) => {
          list.push(data.transporter_name);
          return data;
        });
      }
      // console.log(list)
      if (!list.includes(e.transporter_name)) {
        var objDiv = "";
        if (!existingTransporters.includes(e.transporter_id)) {
          e.is_shortlist = true;
          settransporterList([...transporterList, e]);
          objDiv = document.getElementById("table-wrapper");
          objDiv.scrollTop = objDiv.scrollHeight + 100;
          setSearchText();
          settogglesearch(false);
        } else {
          e.is_shortlist = false;
          settransporterList([...transporterList, e]);
          objDiv = document.getElementById("table-wrapper");
          objDiv.scrollTop = objDiv.scrollHeight + 100;
          setSearchText();
          settogglesearch(false);
        }
        // e.is_shortlist = true
        // settransporterList([...transporterList, e])
        // var objDiv = document.getElementById("table-wrapper");
        // objDiv.scrollTop = objDiv.scrollHeight + 100;
        // setSearchText()
        // settogglesearch(false)
      } else {
        toast.info("transporter already exists");
      }
    };

    const transporterSubmit = (e) => {
      // console.log(item.indent_info.shortlisted_transporters)
      // console.log(transporterList)
      Activity([
        {
          screen: "Indents",
          module: "Private Marketplace",
          user_activity: `Submit button clicked on shortlisting transporters on private marketplace pop-up`,
          timestamp: currentRequestTimeStamp(),
          "userEmail": userDetails?.email, "userName": userDetails?.user_name, companyname:userDetails.company_name
            ? userDetails.company_name
            : userDetails.email
              ? userDetails.email.split("@")[1].split(".")[0]
              : ""
        },
      ]);

      var list = [];
      if (transporterList && transporterList.length > 0) {
        transporterList.map((data) => {
          if (data.is_shortlist === true) {
            list.push(data);
          }
          return data;
        });
      }
      if (list.length > 0) {
        toast.success("transporters shortlisted successfully");
        // console.log(list)
        // closeModal()
        document.getElementById("close_contactus1").click();
        settogglesearch(false);
      } else {
        toast.info("Please select transporters and click on submit");
        // closeModal()
        document.getElementById("close_contactus1").click();
        settogglesearch(false);
      }
    };

    const selectAll = (e) => {
      if (e.target.checked) {
        if (transporterList && transporterList.length > 0) {
          transporterList.map((data, index) =>
            existingTransporters.includes(data.transporter_id)
              ? ((data.is_shortlist = false),
                (document.getElementById(`checkbox${index}`).checked = false))
              : ((data.is_shortlist = true),
                (document.getElementById(`checkbox${index}`).checked = true))
          );
        }
      } else {
        if (transporterList && transporterList.length > 0) {
          transporterList.map((data, index) => {
            data.is_shortlist = false;
            document.getElementById(`checkbox${index}`).checked = false;
            return data;
          });
        }
      }
    };

    return (
      <div>
        <div id="table-wrapper" className="table-wrapper">
          <input
            className={`mb-3 ${classes["s-checkbox"]}`}
            style={{ marginLeft: "2.2%" }}
            type="checkbox"
            onChange={(e) => selectAll(e)}
          />{" "}
          <b className="ml-3">Select All</b>
          {transporterList && transporterList.length
            ? transporterList.map((data, index) => (
              <div
                key={`${data.transporter_id}_${index}`}
                className={`d-flex flex-row ml-2 justify-content-around border-bottom w-100 mb-2`}
              >
                <div className={`w-75 d-flex align-items-center`}>
                  <input
                    id={`checkbox${index}`}
                    className={classes["s-checkbox"]}
                    type="checkbox"
                    onChange={(e) => check_selection(e, data)}
                    defaultChecked={data.is_shortlist}
                    disabled={existingTransporters.includes(
                      data.transporter_id
                    )}
                  />
                  {/* <a style={{ marginLeft: "2%" }} href={`/tpmp/${encryptor(data.transporter_id, true)}`} target="_blank" rel="noopener noreferrer">
                                    {existingTransporters.includes(data.transporter_id) ?
                                        <span style={{ cursor: 'no-drop', color: 'grey' }}>
                                            {Uppercase(data.transporter_name)}
                                        </span>
                                        :
                                        Uppercase(data.transporter_name)
                                    }
                                </a> */}
                  {existingTransporters.includes(data.transporter_id) ? (
                    <ProfileModal
                      transporter_id={data.transporter_id}
                      transporter_name={data.transporter_name}
                      screenName={"Indents Request"}
                      moduleName={"LoRRI Indents"}
                      style={{ cursor: "no-drop", color: "grey" }}
                    />
                  ) : (
                    <ProfileModal
                      transporter_id={data.transporter_id}
                      transporter_name={data.transporter_name}
                      screenName={"Indents Request"}
                      moduleName={"LoRRI Indents"}
                    />
                  )}
                </div>
                <div className={`${classes["s-star-div"]}`}>
                  {existingTransporters.includes(data.transporter_id) ? (
                    <Rating
                      initialRating={
                        data.industry_rating
                          ? data.industry_rating.overall_rating
                          : data.overall_rating
                      }
                      readonly={true}
                      style={{ float: "none" }}
                      emptySymbol={`fa fa-star ${classes["star-1"]}`}
                      fullSymbol={`fa fa-star ${classes["star-1-selected"]}`}
                    />
                  ) : (
                    <Rating
                      initialRating={
                        data.industry_rating
                          ? data.industry_rating.overall_rating
                          : data.overall_rating
                      }
                      readonly={true}
                      style={{ float: "none" }}
                      emptySymbol={`fa fa-star ${classes["star-1"]}`}
                      fullSymbol={`fa fa-star ${classes["star-1-selected"]}`}
                    />
                  )}
                </div>
              </div>
            ))
            : null}
        </div>
        {togglesearch ? (
          <div className="suggestion-wrapper">
            <Autosuggestor
              value={searchText}
              onChange={(e) => setSearchText(e)}
              onSelect={(e) => setSearchText(e)}
              getResults={(e) => addtolist(e)}
            />
          </div>
        ) : null}
        <div style={{ textAlign: "center", marginTop: "2%" }}>
          <button
            onClick={(e) => settogglesearch(true)}
            className="btn btn-primary"
          >
            Add Transporter
          </button>
        </div>

        <div style={{ textAlign: "center", marginTop: "2%" }}>
          <button
            className="btn btn-success"
            onClick={(e) => transporterSubmit(e)}
          >
            Submit
          </button>
        </div>
      </div>
    );
  };

  const changeHandler = (value, name) => {
    item.indent_info[name] = value;
    if (name === "placement_date") {
      setplacementDate(value);
    }
  };

  const PMIndentSubmit = debounce((e) => {
    var list = [];
    var mindate = new Date();
    var day = ("0" + (mindate.getDate() + 1)).slice(-2);
    var month = ("0" + (mindate.getMonth() + 1)).slice(-2);
    var year = mindate.getFullYear();
    // console.log(day + month + year)
    var today_date =
      year.toString() + "-" + month.toString() + "-" + day.toString() + "";
    // console.log(today_date)
    // console.log(placementDate)
    if (transporterList && transporterList.length > 0) {
      transporterList.map((data) => {
        if (data.is_shortlist === true) {
          list.push(data);
        }
        return data;
      });
    }

    // var temp = {
    //     "placement_date": item.indent_info.placement_date,
    //     "shortlisted_transporters": list,
    //     "destination": item.indent_info.destination,
    //     "origin": item.indent_info.origin,
    //     "truck_required": item.indent_info.truck_required,
    //     "truck_types": item.indent_info.truck_types,
    //     "pre_pm_indent_id": item.indent_id,
    //     "termsandconditons": terms
    // }
    // console.log(temp)
    // console.log(placementDate)
    // console.log(today_date)
    if (list.length === 0) {
      toast.error(
        "Please shortlist transporters to whom the enquiry will be floated"
      );
    } else if (
      item.indent_info.truck_required === 0 ||
      item.indent_info.truck_required === "0" ||
      item.indent_info.truck_required === ""
    ) {
      toast.error("Number of trucks cannot be zero or empty");
    } else if (
      item.indent_info.placement_date === undefined ||
      item.indent_info.placement_date === "" ||
      placementDate < today_date
    ) {
      toast.error("Placement Date cannot be empty or less than current date");
    } else {
      Activity([
        {
          screen: "Indents",
          module: "Private Marketplace",
          user_activity: `Submit button clicked on private marketplace pop-up`,
          timestamp: currentRequestTimeStamp(),
          "userEmail": userDetails?.email, "userName": userDetails?.user_name, companyname:userDetails.company_name
            ? userDetails.company_name
            : userDetails.email
              ? userDetails.email.split("@")[1].split(".")[0]
              : ""
        },
      ]);

      // API call
      setshow(true);
      axios
        .post(`${Urls.indent}?field=private_market_indent`, {
          indents: [
            {
              placement_date: item.indent_info.placement_date,
              shortlisted_transporters: list,
              destination: item.indent_info.destination,
              origin: item.indent_info.origin,
              truck_required: item.indent_info.truck_required,
              truck_types: item.indent_info.truck_types,
              pre_pm_indent_id: item.indent_id,
              termsandconditons: terms,
            },
          ],
        })
        .then((res) => {
          // console.log(res.data)
          toast.success("Enquiry Floated to private marketplace successfully!");
          getIndents();
          // setnewfilters('active')
          setshow(false);

          document.getElementById("close_contactus1").click();
        })
        .catch((err) => {
          console.log(err);
          setshow(false);
        });
      // API call
    }
  }, 2000);

  return (
    <div>
      <Loader show={show} />
      <div className="">
        {/* Desktop table - hidden on mobile */}
        <div className="d-none d-md-block">
          <table>
            <thead>
              <tr>
                <th style={{ textAlign: "center" }}>Origin</th>
                <th style={{ textAlign: "center" }}>Destination</th>
                <th style={{ textAlign: "center" }}>Truck Type</th>
                <th style={{ textAlign: "center" }}># Truck Required</th>
                <th style={{ textAlign: "center" }}>Date of Placement</th>
                <th style={{ textAlign: "center" }}>Shortlist Transporters</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{item.indent_info.origin.location_name}</td>
                <td>{item.indent_info.destination.location_name}</td>
                <td>{item.indent_info.truck_types[0]?.value}</td>
                <td>
                  <input
                    style={{ height: "38px", marginTop: "12%" }}
                    type="text"
                    defaultValue={item.indent_info.truck_required}
                    disabled={true}
                    onInput={(e) =>
                      changeHandler(e.target.value, "truck_required")
                    }
                  ></input>
                </td>
                <td>
                  <input
                    style={{ height: "38px" }}
                    type="date"
                    defaultValue={placementDate}
                    min={todaydate}
                    onInput={(e) =>
                      changeHandler(e.target.value, "placement_date")
                    }
                  ></input>
                </td>
                <td>
                  <Modal
                    buttonLabel={`View Transporters`}
                    buttonClass="btn btn-link"
                    content={
                      <ViewLsp
                        transporters={item.indent_info.shortlisted_transporters}
                      />
                    }
                    size="md"
                    title="Shortlist Transporters"
                    id="editenquiry"
                    screenName="Private Marketplace"
                    moduleName="Private Marketplace"
                    activityName={`View LSP Button clicked for ${item.indent_info.origin.location_name} to ${item.indent_info.destination.location_name}`}
                    backdrop={true}
                    closeButtonId="close_contactus1"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Mobile card view - hidden on desktop */}
        <div className="d-md-none" style={{ fontSize: '14px' }}>
          <div style={{ border: '1px solid #dee2e6', borderRadius: '8px', padding: '12px', marginBottom: '12px', backgroundColor: '#f8f9fa' }}>
            <div style={{ marginBottom: '8px' }}>
              <span style={{ fontWeight: '600', color: '#393186' }}>Origin: </span>
              <span>{item.indent_info.origin.location_name}</span>
            </div>
            <div style={{ marginBottom: '8px' }}>
              <span style={{ fontWeight: '600', color: '#393186' }}>Destination: </span>
              <span>{item.indent_info.destination.location_name}</span>
            </div>
            <div style={{ marginBottom: '8px' }}>
              <span style={{ fontWeight: '600', color: '#393186' }}>Truck Type: </span>
              <span>{item.indent_info.truck_types[0]?.value}</span>
            </div>
            <div style={{ marginBottom: '8px' }}>
              <span style={{ fontWeight: '600', color: '#393186' }}># Trucks Required: </span>
              <input
                style={{ height: '32px', width: '70px', display: 'inline-block', marginLeft: '4px' }}
                type="text"
                defaultValue={item.indent_info.truck_required}
                disabled={true}
                onInput={(e) => changeHandler(e.target.value, "truck_required")}
              />
            </div>
            <div style={{ marginBottom: '8px' }}>
              <span style={{ fontWeight: '600', color: '#393186' }}>Date of Placement: </span>
              <input
                style={{ height: '32px', marginLeft: '4px' }}
                type="date"
                defaultValue={placementDate}
                min={todaydate}
                onInput={(e) => changeHandler(e.target.value, "placement_date")}
              />
            </div>
            <div style={{ marginBottom: '4px' }}>
              <span style={{ fontWeight: '600', color: '#393186' }}>Transporters: </span>
              <Modal
                buttonLabel={`View Transporters`}
                buttonClass="btn btn-link btn-sm"
                content={
                  <ViewLsp
                    transporters={item.indent_info.shortlisted_transporters}
                  />
                }
                size="md"
                title="Shortlist Transporters"
                id="editenquiry"
                screenName="Private Marketplace"
                moduleName="Private Marketplace"
                activityName={`View LSP Button clicked for ${item.indent_info.origin.location_name} to ${item.indent_info.destination.location_name}`}
                backdrop={true}
                closeButtonId="close_contactus1"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center">
        <button onClick={(e) => PMIndentSubmit(e)} className="btn btn-success">
          Submit
        </button>
      </div>
    </div>
  );
};

export default PrivateMarketplace;
